<template>
    <createTriviaComponent />
</template>

<script>
import createTriviaComponent from "@/views/trivia/pages/create_trivia/components/create_trivia_component.vue"
export default {
    name: "createTriviaPage",
    components: {
        createTriviaComponent
    },
}
</script>

<style lang="css" scoped>
</style>
